<template>
  <h1>Locker Usage</h1>

  <div class="content-section filters">

    <div class="alert alert-warning" role="alert">After setting filters or changing sorting order, click "Apply filters"
      to re-query the database</div>
    <div class="row">
      <div class="col-md-4">
        <FormKit
            type="datepicker"
            label="Start Date"
            v-model="selectedStartDate"
            format="DD/MM/YYYY"
            timezone="Europe/London"
            clearable
            :key="datepickerClearedKey"
        ></FormKit>
      </div>

      <div class="col-md-4">
        <FormKit
            type="datepicker"
            label="End Date"
            v-model="selectedEndDate"
            format="DD/MM/YYYY"
            timezone="Europe/London"
            clearable
            :key="datepickerClearedKey"
        ></FormKit>
      </div>
      <div class="col-md-4">
        <FormKit
            v-model="selectedLockerStatus"
            type="radio"
            label="Locker Status"
            :options="{
              unused: 'Unused',
              hogged: 'Hogged',
              both: 'Both'
            }"
            outer-class="inline-input"
        />
      </div>
    </div>

    <div class="action-bar">
      <button @click="clearFilter" id="clearFilter">Clear filter</button>&#160;
      <button @click="exportZip" id="exportZip">Export Logs</button>&#160;
      <button @click="applyFilter" id="applyFilter1">Apply filter</button>
    </div>

    <div v-if="isListing">

      <easy-data-table
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
          :headers="headers"
          :items="lockerUsage"
          :search-field="searchField"
          :search-value="searchValue"
          :loading="loading"
          alternating
          border-cell
          buttons-pagination
          multi-sort
      >
        <template #header="header">
          <div class="customize-header">

            {{ header.text }}<br />

            <input v-if="header.value !== 'operations'" v-show="header.value !== 'locker_type'" type="text" :id="'filter-' + header.value" @click.stop />
            <button v-else @click="applyFilter" id="applyFilter2">Apply filter</button>
          </div>
        </template>

        <template #item-date_last_used="item">
          {{formatDateEN(item.date_last_used)}}
        </template>

        <template #item-locker_type="item">
          <div v-if="item.Order_count > 0">Hogged</div>
          <div v-else>Unused</div>
        </template>

        <template #item-customer_name="item">
          <router-link :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
            <div> {{item.firstname}} {{item.surname}}</div>
          </router-link>
        </template>

        <template #item-last_user_name="item">
          <router-link :to="{ name: 'ViewCustomer', params: { id: item.customer_id } }">
            <div>{{ item.customer_id }}</div>
          </router-link>
        </template>

      </easy-data-table>
    </div>
  </div>
</template>


<script setup>
import {ref, watch} from "vue";
import ReportService from "@/services/ReportService";

const lockerUsage =  ref([]);
const searchField = ref("datedue");
const searchValue = ref("");

const nowDate = new Date();
const currentDate = new Date(Date.UTC(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate()));
const defaultStartDate = new Date(new Date().setDate(currentDate.getDate() - 30));
const defaultEndDate = new Date(new Date().setDate(currentDate.getDate() ));

const selectedStartDate = ref(defaultStartDate);
const selectedEndDate = ref(defaultEndDate);
const selectedLockerStatus = ref("hogged");
const datepickerClearedKey = ref(0);

const forceRenderDatepicker = () => {
  datepickerClearedKey.value += 1;
};
const headers = [
  { text: "Locker", value: "locker_id_collect", sortable: true  },
  { text: "Location Name", value: "locationname", sortable: true  },
  { text: "Location ID", value: "locationid", sortable: true  },
  { text: "Building Name", value: "building", sortable: true  },
  { text: "Building ID", value: "buildingid", sortable: true  },
  { text: "Date last used", value: "timeplaced", sortable: true  },
  { text: "Customer Name", value: "customer_name", sortable: true  },
  { text: "No. of orders", value: "Order_count", sortable: true },
  { text: "Locker Type", value: "locker_type", sortable: true },

  { text: "Actions", value: "operations" }
];

const isListing = ref(true);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  //sortBy: ["datedue"],
  sortType: ["desc"],
  exportFormat: "none",
  start_date: defaultStartDate,
  end_date: defaultEndDate,
  locker_type: selectedLockerStatus
});

const formatDateTimeEN = (date) => {
  //25/12/2023
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  var formatDate = new Date(date).toLocaleDateString('en-GB', options);
  var formatTime = new Date(date).toLocaleTimeString('en-GB');
  return formatDate+' '+formatTime;
}

const formatDateEN = (date) => {
  //25/12/2023
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  var formatDate = new Date(date).toLocaleDateString('en-GB', options);
  return formatDate;
}

const  createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}
const loadFromServer = async () => {
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await ReportService.searchLockerUsage(serverOptions.value);
  lockerUsage.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
};

const applyFilter = (resetPage) => {
  let filters = {};
  let updateOptions = serverOptions.value;
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = document.getElementById("filter-" + filterProperty).value;
    }
  }
  updateOptions.filters = filters;

  if (selectedStartDate.value !== "" && typeof selectedStartDate.value != "undefined") {
    selectedStartDate.value = createDateAsUTC(new Date(selectedStartDate.value));
    updateOptions.start_date = selectedStartDate.value;
  }
  if (selectedEndDate.value !== "" && typeof selectedEndDate.value != "undefined") {
    selectedEndDate.value = createDateAsUTC(new Date(selectedEndDate.value));
    updateOptions.end_date = selectedEndDate.value;
  }
  if (selectedLockerStatus.value !== "" && typeof selectedLockerStatus.value != "undefined") {
    updateOptions.locker_type = selectedLockerStatus.value;
  }
  if (resetPage) {
    updateOptions.page = 1;
  }
  serverOptions.value = updateOptions;
  loadFromServer();
};

const exportZip = async () => {
  loading.value = true;
  await ReportService.downloadLockerUsage(serverOptions.value);
  loading.value = false;
};

const clearFilter = () => {
  let filters = {};
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = "";
      document.getElementById("filter-" + filterProperty).value = "";
    }
  }

  const updateServerOptions = serverOptions.value;
  updateServerOptions.filters = filters;
  selectedStartDate.value = "";
  selectedEndDate.value = "";
  serverOptions.value = updateServerOptions;

  forceRenderDatepicker();
  loadFromServer();
};

// initial load
loadFromServer();

watch(() => serverOptions.value.page, () => {
  applyFilter(false)
});

</script>